import router from '@/router'
import { AppSidebar, AppHeader } from '@/components'
import FooterOutgoingLinks from '@/components/FooterOutgoingLinks.vue'

export default (enableCreditHealthCheck, enableCreditScorePage) => {
  initRoutes(enableCreditHealthCheck, enableCreditScorePage)
}

function initRoutes(enableCreditHealthCheck, enableCreditScorePage) {
  if (enableCreditHealthCheck) {
    router.addRoute({
      path: '/credit-health-check-page',
      name: 'credit-health-check-page',
      components: {
        default: () => import('./creditPassport.vue'),
        header: AppHeader,
        footer: FooterOutgoingLinks
      },
      meta: {
        permissions: {
          roles: ['user'],
          redirectTo: {
            name: 'login'
          }
        }
      }
    })
    router.addRoute({
      path: '/credit-health-check',
      name: 'credit-health-check',
      components: {
        default: () => import('./creditPassport.vue'),
        sidebar: AppSidebar,
        header: AppHeader,
        footer: FooterOutgoingLinks
      },
      meta: {
        documentTitle: 'Credit affordability',
        permissions: {
          roles: ['user'],
          redirectTo: {
            name: 'login'
          }
        }
      }
    })
  }
  if (enableCreditScorePage) {
    router.addRoute({
      path: '/credit-health-check/report',
      name: 'credit-score',
      components: {
        default: () => import('../creditScore/creditScore.vue'),
        sidebar: AppSidebar,
        header: AppHeader
      },
      meta: {
        permissions: {
          roles: ['user'],
          redirectTo: {
            name: 'login'
          }
        }
      }
    })
  }
}
